// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__GDyYJ","link":"styles_link__538+X"};